import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {FormBuilder, Validators} from '@angular/forms';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {Store} from '@ngrx/store';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'lib-send-password',
  templateUrl: './send-password.component.html',
  styleUrls: ['./send-password.component.scss']
})
export class SendPasswordComponent implements OnInit, OnDestroy {

  sendPasswordForm: any;
  sendPasswordFormErrors: any;
  unsubscribe$ = new Subject<void>();
  result: any;
  isPasswordRequired: boolean;

  constructor(public dialogRef: MatDialogRef<SendPasswordComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              private store: Store<AdminPanelState>,
              private changeDetectorRef: ChangeDetectorRef) {
    this.sendPasswordFormErrors = {
      password: {}
    };
    this.result = {
      sendPassword: null,
      save: false
    };
    this.isPasswordRequired = false;
  }

  ngOnInit() {
    this.sendPasswordForm = this.formBuilder.group({
      generatePassword: [true],
      password: [''],
      passwordChange: [true],
      sendCopyToMe: [false]
    });

    // this.sendPasswordForm.controls['generatePassword'].disable();

    this.sendPasswordForm.valueChanges.subscribe(() => {
      this.onFormValueChanged();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  updatePasswordRequired(event) {
    const passwordControl = this.sendPasswordForm.get('password');
    this.isPasswordRequired = !this.sendPasswordForm.controls['generatePassword'].value;

    if (this.isPasswordRequired) {
      passwordControl.setValidators([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(16),
        Validators.pattern('(?!.*[\\s])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+=><~-]).{8,}')
      ]);
      passwordControl.setErrors(null);
    } else {
      passwordControl.setValidators(null);
      passwordControl.setErrors(null);
      passwordControl.setValue('');
    }
    this.changeDetectorRef.detectChanges();
  }

  onFormValueChanged() {
    for (const field in this.sendPasswordFormErrors) {
      if (!this.sendPasswordFormErrors.hasOwnProperty(field)) {
        continue;
      }

      this.sendPasswordFormErrors[field] = {};
      const control = this.sendPasswordForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.sendPasswordFormErrors[field] = control.errors;
      }
    }
  }

  onSave() {
    if (this.sendPasswordForm.valid) {
      const sendPassword = {
        generatePassword: this.sendPasswordForm.controls['generatePassword'].value,
        password: this.sendPasswordForm.controls['password'].value,
        passwordChange: this.sendPasswordForm.controls['passwordChange'].value,
        sendCopyToMe: this.sendPasswordForm.controls['sendCopyToMe'].value
      };

      this.result.save = true;
      this.result.sendPassword = sendPassword;
    }
  }
}
